import { createContext, useContext, useEffect } from 'react';
import Button from '../../../../components/Button';
import styles from './style.m.less';

type Props = {
    onDismiss: () => void;
};

const dismissCycleSelectHintContext = createContext(false);

export function NewCycleSelectHint({ onDismiss }: Props) {
    const dismissCycleSelectHint = useContext(dismissCycleSelectHintContext);

    useEffect(() => {
        if (dismissCycleSelectHint) {
            onDismiss();
        }
    }, [dismissCycleSelectHint, onDismiss]);

    return (
        <div className={styles.container}>
            <img alt="" src={require('../Arrow.png')} className={styles.arrow} />
            <strong>
                New in <img alt="SI" src={require('../Logo.svg')} className={styles.logo} />:
            </strong>{' '}
            Select multiple cycles for cross-cycle reporting!{' '}
            <Button kind="LINK" onClick={onDismiss}>
                Hide
            </Button>
            .
        </div>
    );
}

export const DismissCycleSelectHintProvider = dismissCycleSelectHintContext.Provider;
